import { AxiosResponse } from 'axios';
import { AuthData, AuthInfo, ResponseDataInterface } from 'types';
import axios from 'utils/axios';

export const authCodesEsia = (code: string): Promise<AxiosResponse<ResponseDataInterface<AuthData<AuthInfo>>>> => {
  return axios.post('/api/v1/auth/esia', {
    code,
  });
};
